unit View.Home;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Controls, WEBLib.Grids,
  XData.Web.Client, WEBLib.ExtCtrls, WEBLib.WebCtrls,
  System.StrUtils, View.Main, UHelperServer, UUtils, UWeb.Enum;

type
  TFViewHome = class(TForm)
    WebLabel1: TLabel;
    XDataClient: TXDataWebClient;
    div_totalizadores_aliados: THTMLDiv;
    DIV_CLIENTES: THTMLDiv;
    CLIENTES: TLabel;
    NUMERO_CLIENTES: TLabel;
    DIV_PRODUTOS: THTMLDiv;
    PRODUTOS: TLabel;
    NUMERO_PRODUTOS: TLabel;
    DIV_FUNCIONARIOS: THTMLDiv;
    FUNCIONARIOS: TLabel;
    NUMERO_FUNCIONARIOS: TLabel;
    DIV_COMPRAS: THTMLDiv;
    COMPRAS: TLabel;
    NUMERO_COMPRAS: TLabel;
    DIV_CONTADORES: THTMLDiv;
    CONTADORES: TLabel;
    NUMERO_CONTADORES: TLabel;
    DIV_FORNECEDORES: THTMLDiv;
    FORNECEDORES: TLabel;
    NUMERO_FORNECEDORES: TLabel;
    DIV_CUPONS: THTMLDiv;
    CUPONS: TLabel;
    NUMERO_CUPONS: TLabel;
    DIV_VENDAS: THTMLDiv;
    VENDAS: TLabel;
    NUMERO_VENDAS: TLabel;
    div_totalizadores_facil: THTMLDiv;
    DIV_ALIADOS_ATIVOS: THTMLDiv;
    ALIADOS_ATIVOS: TLabel;
    NUMERO_ALIADOS_ATIVOS: TLabel;
    DIV_ALIADOS_SUSPENSOS: THTMLDiv;
    ALIADOS_SUSPENSOS: TLabel;
    NUMERO_ALIADOS_SUSPENSOS: TLabel;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA: THTMLDiv;
    ALIADOS_SINCRONIZACAO_ATIVA: TLabel;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA: TLabel;
    DIV_ALIADOS_SEM_PARCEIRO: THTMLDiv;
    ALIADOS_SEM_PARCEIRO: TLabel;
    NUMERO_ALIADOS_SEM_PARCEIRO: TLabel;
    DIV_ALIADOS_SEM_SEGMENTO: THTMLDiv;
    ALIADOS_SEM_SEGMENTO: TLabel;
    NUMERO_ALIADOS_SEM_SEGMENTO: TLabel;
    DIV_ALIADOS_ERRO_SINCRONIZACAO: THTMLDiv;
    ALIADOS_ERRO_SINCRONIZACAO: TLabel;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO: TLabel;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA: THTMLDiv;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA: TLabel;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA: TLabel;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA: THTMLDiv;
    ALIADOS_SINCRONIZACAO_ATRASADA: TLabel;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA: TLabel;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO: THTMLDiv;
    ALIADOS_UTILITARIOS_DESATUALIZADO: TLabel;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO: TLabel;
    div_totalizadores_scripts: THTMLDiv;
    DIV_SCRIPTS: THTMLDiv;
    SCRIPTS: TLabel;
    NUMERO_SCRIPTS: TLabel;
    DIV_SCRIPTS_ERRO: THTMLDiv;
    SCRIPTS_ERRO: TLabel;
    NUMERO_SCRIPTS_ERRO: TLabel;
    DIV_SCRIPTS_EXECUTADOS: THTMLDiv;
    SCRIPTS_EXECUTADOS: TLabel;
    NUMERO_SCRIPTS_EXECUTADOS: TLabel;
    DIV_SCRIPTS_EXECUTAR: THTMLDiv;
    SCRIPTS_EXECUTAR: TLabel;
    NUMERO_SCRIPTS_EXECUTAR: TLabel;
    DIV_TOTAL_SCRIPTS_ALIADOS: THTMLDiv;
    TOTAL_SCRIPTS_ALIADOS: TLabel;
    NUMERO_SCRIPTS_ALIADOS: TLabel;
    DIV_TOKENS_DUPLICADOS: THTMLDiv;
    TOKENS_DUPLICADOS: TLabel;
    NUMERO_TOKENS_DUPLICADOS: TLabel;
    DIV_PRODUTOS_APROVACAO_PENDENTE: THTMLDiv;
    PRODUTOS_APROVACAO_PENDENTE: TLabel;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE: TLabel;
    div_totalizadores_sinc_servidor: THTMLDiv;
    DIV_ALIADOS_SINC_SERV_ATIVA: THTMLDiv;
    SINC_SERV_ALIADOS_ATIVOS: TLabel;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS: TLabel;
    DIV_ALIADOS_SINC_SERV_ERRO: THTMLDiv;
    SINC_SERV_ALIADOS_ERRO: TLabel;
    NUMERO_SINC_SERV_ALIADOS_ERRO: TLabel;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA: THTMLDiv;
    ALIADOS_SINC_SERV_NAO_INICIADA: TLabel;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA: TLabel;
    DIV_ATUALIZAR_DADOS_REDIS: THTMLDiv;
    ATUALIZAR_DADOS_REDIS: TLabel;
    XDataClientAtualizarRTRedis: TXDataWebClient;
    procedure XDataClientLoad(Response: TXDataClientResponse);
    procedure DIV_CLIENTESClick(Sender: TObject);
    procedure DIV_PRODUTOSClick(Sender: TObject);
    procedure DIV_FUNCIONARIOSClick(Sender: TObject);
    procedure DIV_COMPRASClick(Sender: TObject);
    procedure DIV_CONTADORESClick(Sender: TObject);
    procedure DIV_FORNECEDORESClick(Sender: TObject);
    procedure DIV_CUPONSClick(Sender: TObject);
    procedure DIV_VENDASClick(Sender: TObject);
    procedure DIV_SCRIPTSClick(Sender: TObject);
    procedure DIV_PRODUTOS_APROVACAO_PENDENTEClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure ChamarTelaAliado(Sender: TObject);
    procedure ChamarTelaScriptsAliados(Sender: TObject);
    [async]
    procedure DIV_ATUALIZAR_DADOS_REDISClick(Sender: TObject); async;
    procedure XDataClientAtualizarRTRedisError(Error: TXDataClientError);
    procedure XDataClientAtualizarRTRedisLoad(Response: TXDataClientResponse);
  private
  var
    FMaxTotalizadores,
    FQuantidadeTotalizadores : Integer;
    procedure SetTotalizadoresAliado(pResponse: TXDataClientResponse; pFormatSettings : TFormatSettings);
    procedure SetTotalizadoresFacil(pResponse: TXDataClientResponse; pFormatSettings : TFormatSettings);
    procedure SetTotalizadoresScripts(pResponse: TXDataClientResponse; pFormatSettings : TFormatSettings);
  protected procedure LoadDFMValues; override; end;

var
  FViewHome: TFViewHome;

implementation

uses
  JS, XData.Model.Classes,
  ConnectionModule;

{$R *.dfm}



procedure TFViewHome.ChamarTelaAliado(Sender: TObject);
var
  lDiv : THTMLDiv;
begin
  if TUtils.BloquearAcessoMenuDashboard('aliado') then
    Exit;

  lDiv := THTMLDiv(Sender);

  case IndexStr(lDiv.Name, ['DIV_ALIADOS_UTILITARIOS_DESATUALIZADO', 'DIV_ALIADOS_SINCRONIZACAO_ATRASADA',
    'DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA', 'DIV_ALIADOS_SEM_PARCEIRO', 'DIV_ALIADOS_SEM_SEGMENTO',
    'DIV_ALIADOS_ATIVOS', 'DIV_ALIADOS_SUSPENSOS', 'DIV_ALIADOS_SINCRONIZACAO_ATIVA', 'DIV_ALIADOS_ERRO_SINCRONIZACAO',
    'DIV_TOKENS_DUPLICADOS', 'DIV_ALIADOS_SINC_SERV_ATIVA', 'DIV_ALIADOS_SINC_SERV_ERRO', 'DIV_ALIADOS_SINC_SERV_NAO_INICIADA']) of
    0: THelperServer.FFilterParametro := 'UtilitariosDesatualizadoFilter';
    1: THelperServer.FFilterParametro := 'SincronizacaoAtrasadaFilter';
    2: THelperServer.FFilterParametro := 'SincronizacaoNaoIniciadaFilter';
    3: THelperServer.FQuery := '(parceiro_id eq null) and (status ne 2)';
    4: THelperServer.FQuery := '(segmento_id eq null) and (status ne 2)';
    5: THelperServer.FQuery := 'status eq 1';
    6: THelperServer.FQuery := 'status eq 3';
    7: THelperServer.FQuery := 'sincronizar_dados eq 1';
    8: THelperServer.FFilterParametro := 'ErroSincronizacaoFilter';
    9: THelperServer.FQuery := '(status ne 2) and (contains(observacoes, '+QuotedStr('Sincronização desativada por token repetido!')+'))';
    10: THelperServer.FFilterParametro := 'SincronizacaoServRetIniciadaFilter';
    11: THelperServer.FFilterParametro := 'SincronizacaoServRetErroFilter';
    12: THelperServer.FFilterParametro := 'SincronizacaoServRetNaoIniciadaFilter';
  end;

  FViewMain.aliado.OnClick(Sender);
end;

procedure TFViewHome.ChamarTelaScriptsAliados(Sender: TObject);
var
  lDiv : THTMLDiv;
begin
  if TUtils.BloquearAcessoMenuDashboard('scripts_aliados') then
    Exit;

  lDiv := THTMLDiv(Sender);

  case IndexStr(lDiv.Name, ['DIV_SCRIPTS_EXECUTAR', 'DIV_SCRIPTS_EXECUTADOS', 'DIV_SCRIPTS_ERRO']) of
    0: THelperServer.FQuery := 'status eq 0';
    1: THelperServer.FQuery := 'status eq 1';
    2: THelperServer.FQuery := 'status eq 2';
  end;

  FViewMain.scripts_aliados.OnClick(Sender);
end;

procedure TFViewHome.DIV_ATUALIZAR_DADOS_REDISClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'A data de alteração das tabelas da ' +
    'reforma tributária será sincronizada com o Redis.' + sLineBreak + 'Deseja continuar?')) then
  begin
    TUtils.ChamarDivLoading;
    XDataClientAtualizarRTRedis.RawInvoke('ISinc_Servidor_Retaguarda_Service.AtualizarRTRedis', []);
  end;
end;

procedure TFViewHome.DIV_CLIENTESClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('clientes') then
    Exit;

  FViewMain.clientes.OnClick(Sender);
end;

procedure TFViewHome.DIV_COMPRASClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('compras') then
    Exit;

  FViewMain.compras.OnClick(Sender);
end;

procedure TFViewHome.DIV_CONTADORESClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('contadores') then
    Exit;

  FViewMain.contadores.OnClick(Sender);
end;

procedure TFViewHome.DIV_CUPONSClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('cupons') then
    Exit;

  FViewMain.cupons.OnClick(Sender);
end;

procedure TFViewHome.DIV_FORNECEDORESClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('fornecedores') then
    Exit;

  FViewMain.fornecedores.OnClick(Sender);
end;

procedure TFViewHome.DIV_FUNCIONARIOSClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('funcionarios') then
    Exit;

  FViewMain.funcionarios.OnClick(Sender);
end;

procedure TFViewHome.DIV_PRODUTOSClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('produtos') then
    Exit;

  FViewMain.produtos.OnClick(Sender);
end;

procedure TFViewHome.DIV_PRODUTOS_APROVACAO_PENDENTEClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('produtos_associacao') then
    Exit;

  //FViewMain.produtos_associacao.OnClick(Sender);
end;

procedure TFViewHome.DIV_SCRIPTSClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('scripts') then
    Exit;

  FViewMain.scripts.OnClick(Sender);
end;

procedure TFViewHome.DIV_VENDASClick(Sender: TObject);
begin
  if TUtils.BloquearAcessoMenuDashboard('vendas') then
    Exit;

  FViewMain.vendas.OnClick(Sender);
end;

procedure TFViewHome.SetTotalizadoresAliado(pResponse: TXDataClientResponse; pFormatSettings : TFormatSettings);
var
  lTotal : string;
begin
  lTotal := string(TJSObject(pResponse.Result)['total_clientes']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_CLIENTES.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_produtos']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_PRODUTOS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_funcionarios']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_FUNCIONARIOS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_compras']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_COMPRAS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_contadores']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_CONTADORES.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_cupons']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_CUPONS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_vendas']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_VENDAS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_fornecedores']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_FORNECEDORES.Caption := lTotal;

  TUtils.OcultarDivLoading;
end;

procedure TFViewHome.SetTotalizadoresFacil(pResponse: TXDataClientResponse; pFormatSettings : TFormatSettings);
var
  lTotal : string;
  lIndice : Integer;
  lJsonArray: TJSArray;
  lJsonObject: TJSObject;
begin
  lJsonArray := pResponse.ResultAsArray;

  for lIndice := 0 to lJsonArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lJsonArray[lIndice]);
    lTotal := string(lJsonObject['quantidade']);
    lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);

    case IndexStr(string(lJsonObject['tipo']), ['aliados_ativos', 'aliados_suspensos',
      'aliados_sincronizacao_ativa', 'aliados_sem_parceiro', 'aliados_sem_segmento',
      'aliados_erro_sincronizacao', 'aliados_utilitarios_desatualizado', 'aliados_sincronizacao_atrasada',
      'aliados_sincronizacao_nao_iniciada', 'aliados_token_repetido', 'produtos_aprovacao_pendente',
      'aliados_erro_sincronizacao_serv_ret', 'aliados_sincronizacao_iniciada_serv_ret', 'aliados_sincronizacao_nao_iniciada_serv_ret']) of
      0 : NUMERO_ALIADOS_ATIVOS.Caption := lTotal;
      1 : NUMERO_ALIADOS_SUSPENSOS.Caption := lTotal;
      2 : NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.Caption := lTotal;
      3 : NUMERO_ALIADOS_SEM_PARCEIRO.Caption := lTotal;
      4 : NUMERO_ALIADOS_SEM_SEGMENTO.Caption := lTotal;
      5 : NUMERO_ALIADOS_ERRO_SINCRONIZACAO.Caption := lTotal;
      6 : NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.Caption := lTotal;
      7 : NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.Caption := lTotal;
      8 : NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Caption := lTotal;
      9 : NUMERO_TOKENS_DUPLICADOS.Caption := lTotal;
      10 : NUMERO_PRODUTOS_APROVACAO_PENDENTE.Caption := lTotal;
      11 : NUMERO_SINC_SERV_ALIADOS_ERRO.Caption := lTotal;
      12 : NUMERO_SINC_SERV_ALIADOS_ATIVOS.Caption := lTotal;
      13 : NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.Caption := lTotal;
    end;
  end;

  Inc(FQuantidadeTotalizadores);

  if FQuantidadeTotalizadores = FMaxTotalizadores then
    TUtils.OcultarDivLoading;
end;

procedure TFViewHome.SetTotalizadoresScripts(pResponse: TXDataClientResponse;
  pFormatSettings: TFormatSettings);
var
  lTotal : string;
begin
  lTotal := string(TJSObject(pResponse.Result)['total_scripts']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_SCRIPTS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['total_scripts_aliados_cadastrados']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_SCRIPTS_ALIADOS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['scripts_aliados_executar']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_SCRIPTS_EXECUTAR.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['scripts_aliados_executados']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_SCRIPTS_EXECUTADOS.Caption := lTotal;

  lTotal := string(TJSObject(pResponse.Result)['scripts_aliados_erro']);
  lTotal := FormatFloat('#,##0', StrToInt(lTotal), pFormatSettings);
  NUMERO_SCRIPTS_ERRO.Caption := lTotal;

  Inc(FQuantidadeTotalizadores);

  if FQuantidadeTotalizadores = FMaxTotalizadores then
    TUtils.OcultarDivLoading;
end;

procedure TFViewHome.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('home', 'active');
  TUtils.SetPaginaSelecionada;

  if not TUtils.PossuiPermissao('dashboard_service', TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId(div_totalizadores_aliados.ElementID);
    THelperServer.RemoverElementoPorId(div_totalizadores_scripts.ElementID);
    THelperServer.RemoverElementoPorId(div_totalizadores_facil.ElementID);
    THelperServer.RemoverElementoPorId(div_totalizadores_sinc_servidor.ElementID);
    TUtils.OcultarDivLoading;
    Exit;
  end;

  FMaxTotalizadores := 1;
  FQuantidadeTotalizadores := 0;

  TUtils.ChamarDivLoading;

  if TUtils.FUsuario.Aliado = 0 then
  begin
    THelperServer.RemoverElementoPorId(div_totalizadores_aliados.ElementID);

    if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
    begin
      FMaxTotalizadores := 2;

      XDataClient.RawInvoke('IScripts_Service.GetTotalizadoresScripts', []);
      div_totalizadores_scripts.Visible := True;
      //DIV_PRODUTOS_APROVACAO_PENDENTE.Visible := True;
    end
    else
      THelperServer.RemoverElementoPorId(div_totalizadores_scripts.ElementID);

    div_totalizadores_facil.Visible := True;
    div_totalizadores_sinc_servidor.Visible := True;

    XDataClient.RawInvoke('IService.GetTotalizadoresFacil', []);
  end
  else
  begin
    div_totalizadores_aliados.visible := True;
    THelperServer.RemoverElementoPorId(div_totalizadores_facil.ElementID);
    THelperServer.RemoverElementoPorId(div_totalizadores_scripts.ElementID);
    THelperServer.RemoverElementoPorId(div_totalizadores_sinc_servidor.ElementID);

    XDataClient.RawInvoke('IService.GetTotalizadoresAliado', []);
  end;
end;

procedure TFViewHome.XDataClientAtualizarRTRedisError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewHome.XDataClientAtualizarRTRedisLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!')
end;

procedure TFViewHome.XDataClientLoad(Response: TXDataClientResponse);
var
  lMyFormatSettings: TFormatSettings;
begin
  lMyFormatSettings := TFormatSettings.Create;
  lMyFormatSettings.ThousandSeparator := '.';
  lMyFormatSettings.DecimalSeparator := ',';

  case IndexStr(Response.RequestId, ['IService.GetTotalizadoresAliado',
    'IService.GetTotalizadoresFacil', 'IScripts_Service.GetTotalizadoresScripts']) of
    0 : SetTotalizadoresAliado(Response, lMyFormatSettings);
    1 : SetTotalizadoresFacil(Response, lMyFormatSettings);
    2 : SetTotalizadoresScripts(Response, lMyFormatSettings);
  end;
end;

procedure TFViewHome.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create('view.home.title');
  div_totalizadores_aliados := THTMLDiv.Create('div_totalizadores_aliados');
  DIV_CLIENTES := THTMLDiv.Create('DIV_CLIENTES');
  CLIENTES := TLabel.Create('CLIENTES');
  NUMERO_CLIENTES := TLabel.Create('numero_clientes');
  DIV_PRODUTOS := THTMLDiv.Create('DIV_PRODUTOS');
  PRODUTOS := TLabel.Create('PRODUTOS');
  NUMERO_PRODUTOS := TLabel.Create('NUMERO_PRODUTOS');
  DIV_FUNCIONARIOS := THTMLDiv.Create('DIV_FUNCIONARIOS');
  FUNCIONARIOS := TLabel.Create('FUNCIONARIOS');
  NUMERO_FUNCIONARIOS := TLabel.Create('NUMERO_FUNCIONARIOS');
  DIV_COMPRAS := THTMLDiv.Create('DIV_COMPRAS');
  COMPRAS := TLabel.Create('COMPRAS');
  NUMERO_COMPRAS := TLabel.Create('NUMERO_COMPRAS');
  DIV_CONTADORES := THTMLDiv.Create('DIV_CONTADORES');
  CONTADORES := TLabel.Create('CONTADORES');
  NUMERO_CONTADORES := TLabel.Create('NUMERO_CONTADORES');
  DIV_FORNECEDORES := THTMLDiv.Create('DIV_FORNECEDORES');
  FORNECEDORES := TLabel.Create('FORNECEDORES');
  NUMERO_FORNECEDORES := TLabel.Create('NUMERO_FORNECEDORES');
  DIV_CUPONS := THTMLDiv.Create('DIV_CUPONS');
  CUPONS := TLabel.Create('CUPONS');
  NUMERO_CUPONS := TLabel.Create('NUMERO_CUPONS');
  DIV_VENDAS := THTMLDiv.Create('DIV_VENDAS');
  VENDAS := TLabel.Create('VENDAS');
  NUMERO_VENDAS := TLabel.Create('NUMERO_VENDAS');
  div_totalizadores_facil := THTMLDiv.Create('div_totalizadores_facil');
  DIV_ALIADOS_ATIVOS := THTMLDiv.Create('DIV_ALIADOS_ATIVOS');
  ALIADOS_ATIVOS := TLabel.Create('ALIADOS_ATIVOS');
  NUMERO_ALIADOS_ATIVOS := TLabel.Create('NUMERO_ALIADOS_ATIVOS');
  DIV_ALIADOS_SUSPENSOS := THTMLDiv.Create('DIV_ALIADOS_SUSPENSOS');
  ALIADOS_SUSPENSOS := TLabel.Create('ALIADOS_SUSPENSOS');
  NUMERO_ALIADOS_SUSPENSOS := TLabel.Create('NUMERO_ALIADOS_SUSPENSOS');
  DIV_ALIADOS_SINCRONIZACAO_ATIVA := THTMLDiv.Create('DIV_ALIADOS_SINCRONIZACAO_ATIVA');
  ALIADOS_SINCRONIZACAO_ATIVA := TLabel.Create('ALIADOS_SINCRONIZACAO_ATIVA');
  NUMERO_ALIADOS_SINCRONIZACAO_ATIVA := TLabel.Create('NUMERO_ALIADOS_SINCRONIZACAO_ATIVA');
  DIV_ALIADOS_SEM_PARCEIRO := THTMLDiv.Create('DIV_ALIADOS_SEM_PARCEIRO');
  ALIADOS_SEM_PARCEIRO := TLabel.Create('ALIADOS_SEM_PARCEIRO');
  NUMERO_ALIADOS_SEM_PARCEIRO := TLabel.Create('NUMERO_ALIADOS_SEM_PARCEIRO');
  DIV_ALIADOS_SEM_SEGMENTO := THTMLDiv.Create('DIV_ALIADOS_SEM_SEGMENTO');
  ALIADOS_SEM_SEGMENTO := TLabel.Create('ALIADOS_SEM_SEGMENTO');
  NUMERO_ALIADOS_SEM_SEGMENTO := TLabel.Create('NUMERO_ALIADOS_SEM_SEGMENTO');
  DIV_ALIADOS_ERRO_SINCRONIZACAO := THTMLDiv.Create('DIV_ALIADOS_ERRO_SINCRONIZACAO');
  ALIADOS_ERRO_SINCRONIZACAO := TLabel.Create('ALIADOS_ERRO_SINCRONIZACAO');
  NUMERO_ALIADOS_ERRO_SINCRONIZACAO := TLabel.Create('NUMERO_ALIADOS_ERRO_SINCRONIZACAO');
  DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA := THTMLDiv.Create('DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA');
  ALIADOS_SINCRONIZACAO_NAO_INICIADA := TLabel.Create('ALIADOS_SINCRONIZACAO_NAO_INICIADA');
  NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA := TLabel.Create('NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA');
  DIV_ALIADOS_SINCRONIZACAO_ATRASADA := THTMLDiv.Create('DIV_ALIADOS_SINCRONIZACAO_ATRASADA');
  ALIADOS_SINCRONIZACAO_ATRASADA := TLabel.Create('ALIADOS_SINCRONIZACAO_ATRASADA');
  NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA := TLabel.Create('NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA');
  DIV_ALIADOS_UTILITARIOS_DESATUALIZADO := THTMLDiv.Create('DIV_ALIADOS_UTILITARIOS_DESATUALIZADO');
  ALIADOS_UTILITARIOS_DESATUALIZADO := TLabel.Create('ALIADOS_UTILITARIOS_DESATUALIZADO');
  NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO := TLabel.Create('NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO');
  DIV_TOKENS_DUPLICADOS := THTMLDiv.Create('DIV_TOKENS_DUPLICADOS');
  TOKENS_DUPLICADOS := TLabel.Create('TOKENS_DUPLICADOS');
  NUMERO_TOKENS_DUPLICADOS := TLabel.Create('NUMERO_TOKENS_DUPLICADOS');
  DIV_PRODUTOS_APROVACAO_PENDENTE := THTMLDiv.Create('DIV_PRODUTOS_APROVACAO_PENDENTE');
  PRODUTOS_APROVACAO_PENDENTE := TLabel.Create('PRODUTOS_APROVACAO_PENDENTE');
  NUMERO_PRODUTOS_APROVACAO_PENDENTE := TLabel.Create('NUMERO_PRODUTOS_APROVACAO_PENDENTE');
  div_totalizadores_scripts := THTMLDiv.Create('div_totalizadores_scripts');
  DIV_SCRIPTS := THTMLDiv.Create('DIV_SCRIPTS');
  SCRIPTS := TLabel.Create('SCRIPTS');
  NUMERO_SCRIPTS := TLabel.Create('NUMERO_SCRIPTS');
  DIV_SCRIPTS_ERRO := THTMLDiv.Create('DIV_SCRIPTS_ERRO');
  SCRIPTS_ERRO := TLabel.Create('SCRIPTS_ERRO');
  NUMERO_SCRIPTS_ERRO := TLabel.Create('NUMERO_SCRIPTS_ERRO');
  DIV_SCRIPTS_EXECUTADOS := THTMLDiv.Create('DIV_SCRIPTS_EXECUTADOS');
  SCRIPTS_EXECUTADOS := TLabel.Create('SCRIPTS_EXECUTADOS');
  NUMERO_SCRIPTS_EXECUTADOS := TLabel.Create('NUMERO_SCRIPTS_EXECUTADOS');
  DIV_SCRIPTS_EXECUTAR := THTMLDiv.Create('DIV_SCRIPTS_EXECUTAR');
  SCRIPTS_EXECUTAR := TLabel.Create('SCRIPTS_EXECUTAR');
  NUMERO_SCRIPTS_EXECUTAR := TLabel.Create('NUMERO_SCRIPTS_EXECUTAR');
  DIV_TOTAL_SCRIPTS_ALIADOS := THTMLDiv.Create('DIV_TOTAL_SCRIPTS_ALIADOS');
  TOTAL_SCRIPTS_ALIADOS := TLabel.Create('TOTAL_SCRIPTS_ALIADOS');
  NUMERO_SCRIPTS_ALIADOS := TLabel.Create('NUMERO_SCRIPTS_ALIADOS');
  div_totalizadores_sinc_servidor := THTMLDiv.Create('div_totalizadores_sinc_servidor');
  DIV_ALIADOS_SINC_SERV_ATIVA := THTMLDiv.Create('DIV_ALIADOS_SINC_SERV_ATIVA');
  SINC_SERV_ALIADOS_ATIVOS := TLabel.Create('SINC_SERV_ALIADOS_ATIVOS');
  NUMERO_SINC_SERV_ALIADOS_ATIVOS := TLabel.Create('NUMERO_SINC_SERV_ALIADOS_ATIVOS');
  DIV_ALIADOS_SINC_SERV_ERRO := THTMLDiv.Create('DIV_ALIADOS_SINC_SERV_ERRO');
  SINC_SERV_ALIADOS_ERRO := TLabel.Create('SINC_SERV_ALIADOS_ERRO');
  NUMERO_SINC_SERV_ALIADOS_ERRO := TLabel.Create('NUMERO_SINC_SERV_ALIADOS_ERRO');
  DIV_ALIADOS_SINC_SERV_NAO_INICIADA := THTMLDiv.Create('DIV_ALIADOS_SINC_SERV_NAO_INICIADA');
  ALIADOS_SINC_SERV_NAO_INICIADA := TLabel.Create('ALIADOS_SINC_SERV_NAO_INICIADA');
  NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA := TLabel.Create('NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA');
  DIV_ATUALIZAR_DADOS_REDIS := THTMLDiv.Create('DIV_ATUALIZAR_DADOS_REDIS');
  ATUALIZAR_DADOS_REDIS := TLabel.Create('ATUALIZAR_DADOS_REDIS');
  XDataClient := TXDataWebClient.Create(Self);
  XDataClientAtualizarRTRedis := TXDataWebClient.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  div_totalizadores_aliados.BeforeLoadDFMValues;
  DIV_CLIENTES.BeforeLoadDFMValues;
  CLIENTES.BeforeLoadDFMValues;
  NUMERO_CLIENTES.BeforeLoadDFMValues;
  DIV_PRODUTOS.BeforeLoadDFMValues;
  PRODUTOS.BeforeLoadDFMValues;
  NUMERO_PRODUTOS.BeforeLoadDFMValues;
  DIV_FUNCIONARIOS.BeforeLoadDFMValues;
  FUNCIONARIOS.BeforeLoadDFMValues;
  NUMERO_FUNCIONARIOS.BeforeLoadDFMValues;
  DIV_COMPRAS.BeforeLoadDFMValues;
  COMPRAS.BeforeLoadDFMValues;
  NUMERO_COMPRAS.BeforeLoadDFMValues;
  DIV_CONTADORES.BeforeLoadDFMValues;
  CONTADORES.BeforeLoadDFMValues;
  NUMERO_CONTADORES.BeforeLoadDFMValues;
  DIV_FORNECEDORES.BeforeLoadDFMValues;
  FORNECEDORES.BeforeLoadDFMValues;
  NUMERO_FORNECEDORES.BeforeLoadDFMValues;
  DIV_CUPONS.BeforeLoadDFMValues;
  CUPONS.BeforeLoadDFMValues;
  NUMERO_CUPONS.BeforeLoadDFMValues;
  DIV_VENDAS.BeforeLoadDFMValues;
  VENDAS.BeforeLoadDFMValues;
  NUMERO_VENDAS.BeforeLoadDFMValues;
  div_totalizadores_facil.BeforeLoadDFMValues;
  DIV_ALIADOS_ATIVOS.BeforeLoadDFMValues;
  ALIADOS_ATIVOS.BeforeLoadDFMValues;
  NUMERO_ALIADOS_ATIVOS.BeforeLoadDFMValues;
  DIV_ALIADOS_SUSPENSOS.BeforeLoadDFMValues;
  ALIADOS_SUSPENSOS.BeforeLoadDFMValues;
  NUMERO_ALIADOS_SUSPENSOS.BeforeLoadDFMValues;
  DIV_ALIADOS_SINCRONIZACAO_ATIVA.BeforeLoadDFMValues;
  ALIADOS_SINCRONIZACAO_ATIVA.BeforeLoadDFMValues;
  NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.BeforeLoadDFMValues;
  DIV_ALIADOS_SEM_PARCEIRO.BeforeLoadDFMValues;
  ALIADOS_SEM_PARCEIRO.BeforeLoadDFMValues;
  NUMERO_ALIADOS_SEM_PARCEIRO.BeforeLoadDFMValues;
  DIV_ALIADOS_SEM_SEGMENTO.BeforeLoadDFMValues;
  ALIADOS_SEM_SEGMENTO.BeforeLoadDFMValues;
  NUMERO_ALIADOS_SEM_SEGMENTO.BeforeLoadDFMValues;
  DIV_ALIADOS_ERRO_SINCRONIZACAO.BeforeLoadDFMValues;
  ALIADOS_ERRO_SINCRONIZACAO.BeforeLoadDFMValues;
  NUMERO_ALIADOS_ERRO_SINCRONIZACAO.BeforeLoadDFMValues;
  DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.BeforeLoadDFMValues;
  ALIADOS_SINCRONIZACAO_NAO_INICIADA.BeforeLoadDFMValues;
  NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.BeforeLoadDFMValues;
  DIV_ALIADOS_SINCRONIZACAO_ATRASADA.BeforeLoadDFMValues;
  ALIADOS_SINCRONIZACAO_ATRASADA.BeforeLoadDFMValues;
  NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.BeforeLoadDFMValues;
  DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.BeforeLoadDFMValues;
  ALIADOS_UTILITARIOS_DESATUALIZADO.BeforeLoadDFMValues;
  NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.BeforeLoadDFMValues;
  DIV_TOKENS_DUPLICADOS.BeforeLoadDFMValues;
  TOKENS_DUPLICADOS.BeforeLoadDFMValues;
  NUMERO_TOKENS_DUPLICADOS.BeforeLoadDFMValues;
  DIV_PRODUTOS_APROVACAO_PENDENTE.BeforeLoadDFMValues;
  PRODUTOS_APROVACAO_PENDENTE.BeforeLoadDFMValues;
  NUMERO_PRODUTOS_APROVACAO_PENDENTE.BeforeLoadDFMValues;
  div_totalizadores_scripts.BeforeLoadDFMValues;
  DIV_SCRIPTS.BeforeLoadDFMValues;
  SCRIPTS.BeforeLoadDFMValues;
  NUMERO_SCRIPTS.BeforeLoadDFMValues;
  DIV_SCRIPTS_ERRO.BeforeLoadDFMValues;
  SCRIPTS_ERRO.BeforeLoadDFMValues;
  NUMERO_SCRIPTS_ERRO.BeforeLoadDFMValues;
  DIV_SCRIPTS_EXECUTADOS.BeforeLoadDFMValues;
  SCRIPTS_EXECUTADOS.BeforeLoadDFMValues;
  NUMERO_SCRIPTS_EXECUTADOS.BeforeLoadDFMValues;
  DIV_SCRIPTS_EXECUTAR.BeforeLoadDFMValues;
  SCRIPTS_EXECUTAR.BeforeLoadDFMValues;
  NUMERO_SCRIPTS_EXECUTAR.BeforeLoadDFMValues;
  DIV_TOTAL_SCRIPTS_ALIADOS.BeforeLoadDFMValues;
  TOTAL_SCRIPTS_ALIADOS.BeforeLoadDFMValues;
  NUMERO_SCRIPTS_ALIADOS.BeforeLoadDFMValues;
  div_totalizadores_sinc_servidor.BeforeLoadDFMValues;
  DIV_ALIADOS_SINC_SERV_ATIVA.BeforeLoadDFMValues;
  SINC_SERV_ALIADOS_ATIVOS.BeforeLoadDFMValues;
  NUMERO_SINC_SERV_ALIADOS_ATIVOS.BeforeLoadDFMValues;
  DIV_ALIADOS_SINC_SERV_ERRO.BeforeLoadDFMValues;
  SINC_SERV_ALIADOS_ERRO.BeforeLoadDFMValues;
  NUMERO_SINC_SERV_ALIADOS_ERRO.BeforeLoadDFMValues;
  DIV_ALIADOS_SINC_SERV_NAO_INICIADA.BeforeLoadDFMValues;
  ALIADOS_SINC_SERV_NAO_INICIADA.BeforeLoadDFMValues;
  NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.BeforeLoadDFMValues;
  DIV_ATUALIZAR_DADOS_REDIS.BeforeLoadDFMValues;
  ATUALIZAR_DADOS_REDIS.BeforeLoadDFMValues;
  XDataClient.BeforeLoadDFMValues;
  XDataClientAtualizarRTRedis.BeforeLoadDFMValues;
  try
    Name := 'FViewHome';
    Width := 933;
    Height := 450;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 24;
    WebLabel1.Top := 24;
    WebLabel1.Width := 25;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'In'#237'cio';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    div_totalizadores_aliados.SetParentComponent(Self);
    div_totalizadores_aliados.Name := 'div_totalizadores_aliados';
    div_totalizadores_aliados.Left := 24;
    div_totalizadores_aliados.Top := 51;
    div_totalizadores_aliados.Width := 538;
    div_totalizadores_aliados.Height := 145;
    div_totalizadores_aliados.ChildOrder := 18;
    div_totalizadores_aliados.Role := '';
    div_totalizadores_aliados.Visible := False;
    DIV_CLIENTES.SetParentComponent(div_totalizadores_aliados);
    DIV_CLIENTES.Name := 'DIV_CLIENTES';
    DIV_CLIENTES.Left := 8;
    DIV_CLIENTES.Top := 75;
    DIV_CLIENTES.Width := 100;
    DIV_CLIENTES.Height := 62;
    DIV_CLIENTES.Cursor := crHandPoint;
    DIV_CLIENTES.ChildOrder := 5;
    DIV_CLIENTES.Role := '';
    SetEvent(DIV_CLIENTES, Self, 'OnClick', 'DIV_CLIENTESClick');
    CLIENTES.SetParentComponent(DIV_CLIENTES);
    CLIENTES.Name := 'CLIENTES';
    CLIENTES.Left := 24;
    CLIENTES.Top := 21;
    CLIENTES.Width := 38;
    CLIENTES.Height := 13;
    CLIENTES.Caption := 'Clientes';
    CLIENTES.HeightPercent := 100.000000000000000000;
    CLIENTES.WidthPercent := 100.000000000000000000;
    NUMERO_CLIENTES.SetParentComponent(DIV_CLIENTES);
    NUMERO_CLIENTES.Name := 'NUMERO_CLIENTES';
    NUMERO_CLIENTES.Left := 32;
    NUMERO_CLIENTES.Top := 43;
    NUMERO_CLIENTES.Width := 3;
    NUMERO_CLIENTES.Height := 13;
    NUMERO_CLIENTES.HeightPercent := 100.000000000000000000;
    NUMERO_CLIENTES.WidthPercent := 100.000000000000000000;
    DIV_PRODUTOS.SetParentComponent(div_totalizadores_aliados);
    DIV_PRODUTOS.Name := 'DIV_PRODUTOS';
    DIV_PRODUTOS.Left := 112;
    DIV_PRODUTOS.Top := 75;
    DIV_PRODUTOS.Width := 100;
    DIV_PRODUTOS.Height := 62;
    DIV_PRODUTOS.Cursor := crHandPoint;
    DIV_PRODUTOS.ChildOrder := 5;
    DIV_PRODUTOS.Role := '';
    SetEvent(DIV_PRODUTOS, Self, 'OnClick', 'DIV_PRODUTOSClick');
    PRODUTOS.SetParentComponent(DIV_PRODUTOS);
    PRODUTOS.Name := 'PRODUTOS';
    PRODUTOS.Left := 16;
    PRODUTOS.Top := 21;
    PRODUTOS.Width := 43;
    PRODUTOS.Height := 13;
    PRODUTOS.Caption := 'Produtos';
    PRODUTOS.HeightPercent := 100.000000000000000000;
    PRODUTOS.WidthPercent := 100.000000000000000000;
    NUMERO_PRODUTOS.SetParentComponent(DIV_PRODUTOS);
    NUMERO_PRODUTOS.Name := 'NUMERO_PRODUTOS';
    NUMERO_PRODUTOS.Left := 32;
    NUMERO_PRODUTOS.Top := 43;
    NUMERO_PRODUTOS.Width := 3;
    NUMERO_PRODUTOS.Height := 13;
    NUMERO_PRODUTOS.HeightPercent := 100.000000000000000000;
    NUMERO_PRODUTOS.WidthPercent := 100.000000000000000000;
    DIV_FUNCIONARIOS.SetParentComponent(div_totalizadores_aliados);
    DIV_FUNCIONARIOS.Name := 'DIV_FUNCIONARIOS';
    DIV_FUNCIONARIOS.Left := 216;
    DIV_FUNCIONARIOS.Top := 4;
    DIV_FUNCIONARIOS.Width := 100;
    DIV_FUNCIONARIOS.Height := 62;
    DIV_FUNCIONARIOS.Cursor := crHandPoint;
    DIV_FUNCIONARIOS.ChildOrder := 5;
    DIV_FUNCIONARIOS.Role := '';
    SetEvent(DIV_FUNCIONARIOS, Self, 'OnClick', 'DIV_FUNCIONARIOSClick');
    FUNCIONARIOS.SetParentComponent(DIV_FUNCIONARIOS);
    FUNCIONARIOS.Name := 'FUNCIONARIOS';
    FUNCIONARIOS.Left := 7;
    FUNCIONARIOS.Top := 21;
    FUNCIONARIOS.Width := 60;
    FUNCIONARIOS.Height := 13;
    FUNCIONARIOS.Caption := 'Funcion'#225'rios';
    FUNCIONARIOS.HeightPercent := 100.000000000000000000;
    FUNCIONARIOS.WidthPercent := 100.000000000000000000;
    NUMERO_FUNCIONARIOS.SetParentComponent(DIV_FUNCIONARIOS);
    NUMERO_FUNCIONARIOS.Name := 'NUMERO_FUNCIONARIOS';
    NUMERO_FUNCIONARIOS.Left := 32;
    NUMERO_FUNCIONARIOS.Top := 43;
    NUMERO_FUNCIONARIOS.Width := 3;
    NUMERO_FUNCIONARIOS.Height := 13;
    NUMERO_FUNCIONARIOS.HeightPercent := 100.000000000000000000;
    NUMERO_FUNCIONARIOS.WidthPercent := 100.000000000000000000;
    DIV_COMPRAS.SetParentComponent(div_totalizadores_aliados);
    DIV_COMPRAS.Name := 'DIV_COMPRAS';
    DIV_COMPRAS.Left := 320;
    DIV_COMPRAS.Top := 4;
    DIV_COMPRAS.Width := 100;
    DIV_COMPRAS.Height := 62;
    DIV_COMPRAS.Cursor := crHandPoint;
    DIV_COMPRAS.ChildOrder := 5;
    DIV_COMPRAS.Role := '';
    SetEvent(DIV_COMPRAS, Self, 'OnClick', 'DIV_COMPRASClick');
    COMPRAS.SetParentComponent(DIV_COMPRAS);
    COMPRAS.Name := 'COMPRAS';
    COMPRAS.Left := 16;
    COMPRAS.Top := 21;
    COMPRAS.Width := 42;
    COMPRAS.Height := 13;
    COMPRAS.Caption := 'Compras';
    COMPRAS.HeightPercent := 100.000000000000000000;
    COMPRAS.WidthPercent := 100.000000000000000000;
    NUMERO_COMPRAS.SetParentComponent(DIV_COMPRAS);
    NUMERO_COMPRAS.Name := 'NUMERO_COMPRAS';
    NUMERO_COMPRAS.Left := 32;
    NUMERO_COMPRAS.Top := 43;
    NUMERO_COMPRAS.Width := 3;
    NUMERO_COMPRAS.Height := 13;
    NUMERO_COMPRAS.HeightPercent := 100.000000000000000000;
    NUMERO_COMPRAS.WidthPercent := 100.000000000000000000;
    DIV_CONTADORES.SetParentComponent(div_totalizadores_aliados);
    DIV_CONTADORES.Name := 'DIV_CONTADORES';
    DIV_CONTADORES.Left := 424;
    DIV_CONTADORES.Top := 4;
    DIV_CONTADORES.Width := 100;
    DIV_CONTADORES.Height := 62;
    DIV_CONTADORES.Cursor := crHandPoint;
    DIV_CONTADORES.ChildOrder := 5;
    DIV_CONTADORES.Role := '';
    SetEvent(DIV_CONTADORES, Self, 'OnClick', 'DIV_CONTADORESClick');
    CONTADORES.SetParentComponent(DIV_CONTADORES);
    CONTADORES.Name := 'CONTADORES';
    CONTADORES.Left := 7;
    CONTADORES.Top := 21;
    CONTADORES.Width := 56;
    CONTADORES.Height := 13;
    CONTADORES.Caption := 'Contadores';
    CONTADORES.HeightPercent := 100.000000000000000000;
    CONTADORES.WidthPercent := 100.000000000000000000;
    NUMERO_CONTADORES.SetParentComponent(DIV_CONTADORES);
    NUMERO_CONTADORES.Name := 'NUMERO_CONTADORES';
    NUMERO_CONTADORES.Left := 32;
    NUMERO_CONTADORES.Top := 43;
    NUMERO_CONTADORES.Width := 3;
    NUMERO_CONTADORES.Height := 13;
    NUMERO_CONTADORES.HeightPercent := 100.000000000000000000;
    NUMERO_CONTADORES.WidthPercent := 100.000000000000000000;
    DIV_FORNECEDORES.SetParentComponent(div_totalizadores_aliados);
    DIV_FORNECEDORES.Name := 'DIV_FORNECEDORES';
    DIV_FORNECEDORES.Left := 215;
    DIV_FORNECEDORES.Top := 75;
    DIV_FORNECEDORES.Width := 101;
    DIV_FORNECEDORES.Height := 62;
    DIV_FORNECEDORES.Cursor := crHandPoint;
    DIV_FORNECEDORES.ChildOrder := 5;
    DIV_FORNECEDORES.Role := '';
    SetEvent(DIV_FORNECEDORES, Self, 'OnClick', 'DIV_FORNECEDORESClick');
    FORNECEDORES.SetParentComponent(DIV_FORNECEDORES);
    FORNECEDORES.Name := 'FORNECEDORES';
    FORNECEDORES.Left := 15;
    FORNECEDORES.Top := 29;
    FORNECEDORES.Width := 66;
    FORNECEDORES.Height := 13;
    FORNECEDORES.Caption := 'Fornecedores';
    FORNECEDORES.HeightPercent := 100.000000000000000000;
    FORNECEDORES.WidthPercent := 100.000000000000000000;
    NUMERO_FORNECEDORES.SetParentComponent(DIV_FORNECEDORES);
    NUMERO_FORNECEDORES.Name := 'NUMERO_FORNECEDORES';
    NUMERO_FORNECEDORES.Left := 32;
    NUMERO_FORNECEDORES.Top := 43;
    NUMERO_FORNECEDORES.Width := 3;
    NUMERO_FORNECEDORES.Height := 13;
    NUMERO_FORNECEDORES.HeightPercent := 100.000000000000000000;
    NUMERO_FORNECEDORES.WidthPercent := 100.000000000000000000;
    DIV_CUPONS.SetParentComponent(div_totalizadores_aliados);
    DIV_CUPONS.Name := 'DIV_CUPONS';
    DIV_CUPONS.Left := 8;
    DIV_CUPONS.Top := 4;
    DIV_CUPONS.Width := 100;
    DIV_CUPONS.Height := 62;
    DIV_CUPONS.Cursor := crHandPoint;
    DIV_CUPONS.ChildOrder := 5;
    DIV_CUPONS.Role := '';
    SetEvent(DIV_CUPONS, Self, 'OnClick', 'DIV_CUPONSClick');
    CUPONS.SetParentComponent(DIV_CUPONS);
    CUPONS.Name := 'CUPONS';
    CUPONS.Left := 27;
    CUPONS.Top := 21;
    CUPONS.Width := 36;
    CUPONS.Height := 13;
    CUPONS.Caption := 'Cupons';
    CUPONS.HeightPercent := 100.000000000000000000;
    CUPONS.WidthPercent := 100.000000000000000000;
    NUMERO_CUPONS.SetParentComponent(DIV_CUPONS);
    NUMERO_CUPONS.Name := 'NUMERO_CUPONS';
    NUMERO_CUPONS.Left := 32;
    NUMERO_CUPONS.Top := 43;
    NUMERO_CUPONS.Width := 3;
    NUMERO_CUPONS.Height := 13;
    NUMERO_CUPONS.HeightPercent := 100.000000000000000000;
    NUMERO_CUPONS.WidthPercent := 100.000000000000000000;
    DIV_VENDAS.SetParentComponent(div_totalizadores_aliados);
    DIV_VENDAS.Name := 'DIV_VENDAS';
    DIV_VENDAS.Left := 112;
    DIV_VENDAS.Top := 4;
    DIV_VENDAS.Width := 100;
    DIV_VENDAS.Height := 62;
    DIV_VENDAS.Cursor := crHandPoint;
    DIV_VENDAS.ChildOrder := 5;
    DIV_VENDAS.Role := '';
    SetEvent(DIV_VENDAS, Self, 'OnClick', 'DIV_VENDASClick');
    VENDAS.SetParentComponent(DIV_VENDAS);
    VENDAS.Name := 'VENDAS';
    VENDAS.Left := 27;
    VENDAS.Top := 21;
    VENDAS.Width := 35;
    VENDAS.Height := 13;
    VENDAS.Caption := 'Vendas';
    VENDAS.HeightPercent := 100.000000000000000000;
    VENDAS.WidthPercent := 100.000000000000000000;
    NUMERO_VENDAS.SetParentComponent(DIV_VENDAS);
    NUMERO_VENDAS.Name := 'NUMERO_VENDAS';
    NUMERO_VENDAS.Left := 32;
    NUMERO_VENDAS.Top := 43;
    NUMERO_VENDAS.Width := 3;
    NUMERO_VENDAS.Height := 13;
    NUMERO_VENDAS.HeightPercent := 100.000000000000000000;
    NUMERO_VENDAS.WidthPercent := 100.000000000000000000;
    div_totalizadores_facil.SetParentComponent(Self);
    div_totalizadores_facil.Name := 'div_totalizadores_facil';
    div_totalizadores_facil.Left := 24;
    div_totalizadores_facil.Top := 208;
    div_totalizadores_facil.Width := 538;
    div_totalizadores_facil.Height := 225;
    div_totalizadores_facil.ChildOrder := 11;
    div_totalizadores_facil.Role := '';
    div_totalizadores_facil.Visible := False;
    DIV_ALIADOS_ATIVOS.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_ATIVOS.Name := 'DIV_ALIADOS_ATIVOS';
    DIV_ALIADOS_ATIVOS.Left := 8;
    DIV_ALIADOS_ATIVOS.Top := 83;
    DIV_ALIADOS_ATIVOS.Width := 100;
    DIV_ALIADOS_ATIVOS.Height := 62;
    DIV_ALIADOS_ATIVOS.Cursor := crHandPoint;
    DIV_ALIADOS_ATIVOS.ChildOrder := 5;
    DIV_ALIADOS_ATIVOS.Role := '';
    SetEvent(DIV_ALIADOS_ATIVOS, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_ATIVOS.SetParentComponent(DIV_ALIADOS_ATIVOS);
    ALIADOS_ATIVOS.Name := 'ALIADOS_ATIVOS';
    ALIADOS_ATIVOS.Left := 16;
    ALIADOS_ATIVOS.Top := 24;
    ALIADOS_ATIVOS.Width := 67;
    ALIADOS_ATIVOS.Height := 13;
    ALIADOS_ATIVOS.Caption := 'Aliados Ativos';
    ALIADOS_ATIVOS.HeightPercent := 100.000000000000000000;
    ALIADOS_ATIVOS.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_ATIVOS.SetParentComponent(DIV_ALIADOS_ATIVOS);
    NUMERO_ALIADOS_ATIVOS.Name := 'NUMERO_ALIADOS_ATIVOS';
    NUMERO_ALIADOS_ATIVOS.Left := 32;
    NUMERO_ALIADOS_ATIVOS.Top := 43;
    NUMERO_ALIADOS_ATIVOS.Width := 3;
    NUMERO_ALIADOS_ATIVOS.Height := 13;
    NUMERO_ALIADOS_ATIVOS.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_ATIVOS.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SUSPENSOS.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_SUSPENSOS.Name := 'DIV_ALIADOS_SUSPENSOS';
    DIV_ALIADOS_SUSPENSOS.Left := 112;
    DIV_ALIADOS_SUSPENSOS.Top := 83;
    DIV_ALIADOS_SUSPENSOS.Width := 100;
    DIV_ALIADOS_SUSPENSOS.Height := 62;
    DIV_ALIADOS_SUSPENSOS.Cursor := crHandPoint;
    DIV_ALIADOS_SUSPENSOS.ChildOrder := 5;
    DIV_ALIADOS_SUSPENSOS.Role := '';
    SetEvent(DIV_ALIADOS_SUSPENSOS, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SUSPENSOS.SetParentComponent(DIV_ALIADOS_SUSPENSOS);
    ALIADOS_SUSPENSOS.Name := 'ALIADOS_SUSPENSOS';
    ALIADOS_SUSPENSOS.Left := 8;
    ALIADOS_SUSPENSOS.Top := 24;
    ALIADOS_SUSPENSOS.Width := 88;
    ALIADOS_SUSPENSOS.Height := 13;
    ALIADOS_SUSPENSOS.Caption := 'Aliados Suspensos';
    ALIADOS_SUSPENSOS.HeightPercent := 100.000000000000000000;
    ALIADOS_SUSPENSOS.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SUSPENSOS.SetParentComponent(DIV_ALIADOS_SUSPENSOS);
    NUMERO_ALIADOS_SUSPENSOS.Name := 'NUMERO_ALIADOS_SUSPENSOS';
    NUMERO_ALIADOS_SUSPENSOS.Left := 32;
    NUMERO_ALIADOS_SUSPENSOS.Top := 43;
    NUMERO_ALIADOS_SUSPENSOS.Width := 3;
    NUMERO_ALIADOS_SUSPENSOS.Height := 13;
    NUMERO_ALIADOS_SUSPENSOS.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SUSPENSOS.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Name := 'DIV_ALIADOS_SINCRONIZACAO_ATIVA';
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Left := 216;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Top := 83;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Width := 100;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Height := 62;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Cursor := crHandPoint;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.ChildOrder := 5;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.Role := '';
    SetEvent(DIV_ALIADOS_SINCRONIZACAO_ATIVA, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SINCRONIZACAO_ATIVA.SetParentComponent(DIV_ALIADOS_SINCRONIZACAO_ATIVA);
    ALIADOS_SINCRONIZACAO_ATIVA.Name := 'ALIADOS_SINCRONIZACAO_ATIVA';
    ALIADOS_SINCRONIZACAO_ATIVA.Left := 5;
    ALIADOS_SINCRONIZACAO_ATIVA.Top := 17;
    ALIADOS_SINCRONIZACAO_ATIVA.Width := 93;
    ALIADOS_SINCRONIZACAO_ATIVA.Height := 13;
    ALIADOS_SINCRONIZACAO_ATIVA.Caption := 'Sincroniza'#231#227'o Ativa';
    ALIADOS_SINCRONIZACAO_ATIVA.HeightPercent := 100.000000000000000000;
    ALIADOS_SINCRONIZACAO_ATIVA.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.SetParentComponent(DIV_ALIADOS_SINCRONIZACAO_ATIVA);
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.Name := 'NUMERO_ALIADOS_SINCRONIZACAO_ATIVA';
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.Left := 32;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.Top := 43;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.Width := 3;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.Height := 13;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SEM_PARCEIRO.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_SEM_PARCEIRO.Name := 'DIV_ALIADOS_SEM_PARCEIRO';
    DIV_ALIADOS_SEM_PARCEIRO.Left := 320;
    DIV_ALIADOS_SEM_PARCEIRO.Top := 11;
    DIV_ALIADOS_SEM_PARCEIRO.Width := 100;
    DIV_ALIADOS_SEM_PARCEIRO.Height := 62;
    DIV_ALIADOS_SEM_PARCEIRO.Cursor := crHandPoint;
    DIV_ALIADOS_SEM_PARCEIRO.ChildOrder := 5;
    DIV_ALIADOS_SEM_PARCEIRO.Role := '';
    SetEvent(DIV_ALIADOS_SEM_PARCEIRO, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SEM_PARCEIRO.SetParentComponent(DIV_ALIADOS_SEM_PARCEIRO);
    ALIADOS_SEM_PARCEIRO.Name := 'ALIADOS_SEM_PARCEIRO';
    ALIADOS_SEM_PARCEIRO.Left := 6;
    ALIADOS_SEM_PARCEIRO.Top := 11;
    ALIADOS_SEM_PARCEIRO.Width := 99;
    ALIADOS_SEM_PARCEIRO.Height := 13;
    ALIADOS_SEM_PARCEIRO.Caption := 'Aliados Sem Parceiro';
    ALIADOS_SEM_PARCEIRO.HeightPercent := 100.000000000000000000;
    ALIADOS_SEM_PARCEIRO.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SEM_PARCEIRO.SetParentComponent(DIV_ALIADOS_SEM_PARCEIRO);
    NUMERO_ALIADOS_SEM_PARCEIRO.Name := 'NUMERO_ALIADOS_SEM_PARCEIRO';
    NUMERO_ALIADOS_SEM_PARCEIRO.Left := 32;
    NUMERO_ALIADOS_SEM_PARCEIRO.Top := 43;
    NUMERO_ALIADOS_SEM_PARCEIRO.Width := 3;
    NUMERO_ALIADOS_SEM_PARCEIRO.Height := 13;
    NUMERO_ALIADOS_SEM_PARCEIRO.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SEM_PARCEIRO.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SEM_SEGMENTO.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_SEM_SEGMENTO.Name := 'DIV_ALIADOS_SEM_SEGMENTO';
    DIV_ALIADOS_SEM_SEGMENTO.Left := 424;
    DIV_ALIADOS_SEM_SEGMENTO.Top := 11;
    DIV_ALIADOS_SEM_SEGMENTO.Width := 100;
    DIV_ALIADOS_SEM_SEGMENTO.Height := 62;
    DIV_ALIADOS_SEM_SEGMENTO.Cursor := crHandPoint;
    DIV_ALIADOS_SEM_SEGMENTO.ChildOrder := 5;
    DIV_ALIADOS_SEM_SEGMENTO.Role := '';
    SetEvent(DIV_ALIADOS_SEM_SEGMENTO, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SEM_SEGMENTO.SetParentComponent(DIV_ALIADOS_SEM_SEGMENTO);
    ALIADOS_SEM_SEGMENTO.Name := 'ALIADOS_SEM_SEGMENTO';
    ALIADOS_SEM_SEGMENTO.Left := 6;
    ALIADOS_SEM_SEGMENTO.Top := 11;
    ALIADOS_SEM_SEGMENTO.Width := 108;
    ALIADOS_SEM_SEGMENTO.Height := 13;
    ALIADOS_SEM_SEGMENTO.Caption := 'Aliados Sem Segmento';
    ALIADOS_SEM_SEGMENTO.HeightPercent := 100.000000000000000000;
    ALIADOS_SEM_SEGMENTO.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SEM_SEGMENTO.SetParentComponent(DIV_ALIADOS_SEM_SEGMENTO);
    NUMERO_ALIADOS_SEM_SEGMENTO.Name := 'NUMERO_ALIADOS_SEM_SEGMENTO';
    NUMERO_ALIADOS_SEM_SEGMENTO.Left := 32;
    NUMERO_ALIADOS_SEM_SEGMENTO.Top := 43;
    NUMERO_ALIADOS_SEM_SEGMENTO.Width := 3;
    NUMERO_ALIADOS_SEM_SEGMENTO.Height := 13;
    NUMERO_ALIADOS_SEM_SEGMENTO.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SEM_SEGMENTO.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Name := 'DIV_ALIADOS_ERRO_SINCRONIZACAO';
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Left := 322;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Top := 83;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Width := 100;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Height := 62;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Cursor := crHandPoint;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.ChildOrder := 5;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.Role := '';
    SetEvent(DIV_ALIADOS_ERRO_SINCRONIZACAO, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_ERRO_SINCRONIZACAO.SetParentComponent(DIV_ALIADOS_ERRO_SINCRONIZACAO);
    ALIADOS_ERRO_SINCRONIZACAO.Name := 'ALIADOS_ERRO_SINCRONIZACAO';
    ALIADOS_ERRO_SINCRONIZACAO.Left := 9;
    ALIADOS_ERRO_SINCRONIZACAO.Top := 24;
    ALIADOS_ERRO_SINCRONIZACAO.Width := 88;
    ALIADOS_ERRO_SINCRONIZACAO.Height := 13;
    ALIADOS_ERRO_SINCRONIZACAO.Caption := 'Erro Sincroniza'#231#227'o';
    ALIADOS_ERRO_SINCRONIZACAO.HeightPercent := 100.000000000000000000;
    ALIADOS_ERRO_SINCRONIZACAO.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.SetParentComponent(DIV_ALIADOS_ERRO_SINCRONIZACAO);
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.Name := 'NUMERO_ALIADOS_ERRO_SINCRONIZACAO';
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.Left := 32;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.Top := 43;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.Width := 3;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.Height := 13;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Name := 'DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA';
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Left := 216;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Top := 11;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Width := 100;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Height := 62;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Cursor := crHandPoint;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.ChildOrder := 5;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Role := '';
    SetEvent(DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.SetParentComponent(DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA);
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.Name := 'ALIADOS_SINCRONIZACAO_NAO_INICIADA';
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.Left := 0;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.Top := 11;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.Width := 127;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.Height := 13;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.Caption := 'Sincroniza'#231#227'o N'#227'o Iniciada';
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.HeightPercent := 100.000000000000000000;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.SetParentComponent(DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA);
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Name := 'NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA';
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Left := 32;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Top := 43;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Width := 3;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.Height := 13;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Name := 'DIV_ALIADOS_SINCRONIZACAO_ATRASADA';
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Left := 112;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Top := 11;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Width := 100;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Height := 62;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Cursor := crHandPoint;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.ChildOrder := 5;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.Role := '';
    SetEvent(DIV_ALIADOS_SINCRONIZACAO_ATRASADA, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SINCRONIZACAO_ATRASADA.SetParentComponent(DIV_ALIADOS_SINCRONIZACAO_ATRASADA);
    ALIADOS_SINCRONIZACAO_ATRASADA.Name := 'ALIADOS_SINCRONIZACAO_ATRASADA';
    ALIADOS_SINCRONIZACAO_ATRASADA.Left := 0;
    ALIADOS_SINCRONIZACAO_ATRASADA.Top := 11;
    ALIADOS_SINCRONIZACAO_ATRASADA.Width := 112;
    ALIADOS_SINCRONIZACAO_ATRASADA.Height := 13;
    ALIADOS_SINCRONIZACAO_ATRASADA.Caption := 'Sincroniza'#231#227'o Atrasada';
    ALIADOS_SINCRONIZACAO_ATRASADA.HeightPercent := 100.000000000000000000;
    ALIADOS_SINCRONIZACAO_ATRASADA.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.SetParentComponent(DIV_ALIADOS_SINCRONIZACAO_ATRASADA);
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.Name := 'NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA';
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.Left := 32;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.Top := 43;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.Width := 3;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.Height := 13;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.SetParentComponent(div_totalizadores_facil);
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Name := 'DIV_ALIADOS_UTILITARIOS_DESATUALIZADO';
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Left := 8;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Top := 11;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Width := 100;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Height := 62;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Cursor := crHandPoint;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.ChildOrder := 5;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.Role := '';
    SetEvent(DIV_ALIADOS_UTILITARIOS_DESATUALIZADO, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_UTILITARIOS_DESATUALIZADO.SetParentComponent(DIV_ALIADOS_UTILITARIOS_DESATUALIZADO);
    ALIADOS_UTILITARIOS_DESATUALIZADO.Name := 'ALIADOS_UTILITARIOS_DESATUALIZADO';
    ALIADOS_UTILITARIOS_DESATUALIZADO.Left := 0;
    ALIADOS_UTILITARIOS_DESATUALIZADO.Top := 11;
    ALIADOS_UTILITARIOS_DESATUALIZADO.Width := 114;
    ALIADOS_UTILITARIOS_DESATUALIZADO.Height := 13;
    ALIADOS_UTILITARIOS_DESATUALIZADO.Caption := 'Utilit'#225'rios Desatualizado';
    ALIADOS_UTILITARIOS_DESATUALIZADO.HeightPercent := 100.000000000000000000;
    ALIADOS_UTILITARIOS_DESATUALIZADO.WidthPercent := 100.000000000000000000;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.SetParentComponent(DIV_ALIADOS_UTILITARIOS_DESATUALIZADO);
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.Name := 'NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO';
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.Left := 32;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.Top := 43;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.Width := 3;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.Height := 13;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.HeightPercent := 100.000000000000000000;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.WidthPercent := 100.000000000000000000;
    DIV_TOKENS_DUPLICADOS.SetParentComponent(div_totalizadores_facil);
    DIV_TOKENS_DUPLICADOS.Name := 'DIV_TOKENS_DUPLICADOS';
    DIV_TOKENS_DUPLICADOS.Left := 424;
    DIV_TOKENS_DUPLICADOS.Top := 83;
    DIV_TOKENS_DUPLICADOS.Width := 100;
    DIV_TOKENS_DUPLICADOS.Height := 62;
    DIV_TOKENS_DUPLICADOS.Cursor := crHandPoint;
    DIV_TOKENS_DUPLICADOS.ChildOrder := 5;
    DIV_TOKENS_DUPLICADOS.Role := '';
    SetEvent(DIV_TOKENS_DUPLICADOS, Self, 'OnClick', 'ChamarTelaAliado');
    TOKENS_DUPLICADOS.SetParentComponent(DIV_TOKENS_DUPLICADOS);
    TOKENS_DUPLICADOS.Name := 'TOKENS_DUPLICADOS';
    TOKENS_DUPLICADOS.Left := 9;
    TOKENS_DUPLICADOS.Top := 24;
    TOKENS_DUPLICADOS.Width := 88;
    TOKENS_DUPLICADOS.Height := 13;
    TOKENS_DUPLICADOS.Caption := 'Tokens Duplicados';
    TOKENS_DUPLICADOS.HeightPercent := 100.000000000000000000;
    TOKENS_DUPLICADOS.WidthPercent := 100.000000000000000000;
    NUMERO_TOKENS_DUPLICADOS.SetParentComponent(DIV_TOKENS_DUPLICADOS);
    NUMERO_TOKENS_DUPLICADOS.Name := 'NUMERO_TOKENS_DUPLICADOS';
    NUMERO_TOKENS_DUPLICADOS.Left := 32;
    NUMERO_TOKENS_DUPLICADOS.Top := 43;
    NUMERO_TOKENS_DUPLICADOS.Width := 3;
    NUMERO_TOKENS_DUPLICADOS.Height := 13;
    NUMERO_TOKENS_DUPLICADOS.HeightPercent := 100.000000000000000000;
    NUMERO_TOKENS_DUPLICADOS.WidthPercent := 100.000000000000000000;
    DIV_PRODUTOS_APROVACAO_PENDENTE.SetParentComponent(div_totalizadores_facil);
    DIV_PRODUTOS_APROVACAO_PENDENTE.Name := 'DIV_PRODUTOS_APROVACAO_PENDENTE';
    DIV_PRODUTOS_APROVACAO_PENDENTE.Left := 6;
    DIV_PRODUTOS_APROVACAO_PENDENTE.Top := 151;
    DIV_PRODUTOS_APROVACAO_PENDENTE.Width := 100;
    DIV_PRODUTOS_APROVACAO_PENDENTE.Height := 62;
    DIV_PRODUTOS_APROVACAO_PENDENTE.Cursor := crHandPoint;
    DIV_PRODUTOS_APROVACAO_PENDENTE.ChildOrder := 5;
    DIV_PRODUTOS_APROVACAO_PENDENTE.Role := '';
    DIV_PRODUTOS_APROVACAO_PENDENTE.Visible := False;
    SetEvent(DIV_PRODUTOS_APROVACAO_PENDENTE, Self, 'OnClick', 'DIV_PRODUTOS_APROVACAO_PENDENTEClick');
    PRODUTOS_APROVACAO_PENDENTE.SetParentComponent(DIV_PRODUTOS_APROVACAO_PENDENTE);
    PRODUTOS_APROVACAO_PENDENTE.Name := 'PRODUTOS_APROVACAO_PENDENTE';
    PRODUTOS_APROVACAO_PENDENTE.Left := 9;
    PRODUTOS_APROVACAO_PENDENTE.Top := 24;
    PRODUTOS_APROVACAO_PENDENTE.Width := 98;
    PRODUTOS_APROVACAO_PENDENTE.Height := 13;
    PRODUTOS_APROVACAO_PENDENTE.Caption := 'Produtos Aprova'#231#227'o';
    PRODUTOS_APROVACAO_PENDENTE.HeightPercent := 100.000000000000000000;
    PRODUTOS_APROVACAO_PENDENTE.WidthPercent := 100.000000000000000000;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.SetParentComponent(DIV_PRODUTOS_APROVACAO_PENDENTE);
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.Name := 'NUMERO_PRODUTOS_APROVACAO_PENDENTE';
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.Left := 32;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.Top := 43;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.Width := 3;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.Height := 13;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.HeightPercent := 100.000000000000000000;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.WidthPercent := 100.000000000000000000;
    div_totalizadores_scripts.SetParentComponent(Self);
    div_totalizadores_scripts.Name := 'div_totalizadores_scripts';
    div_totalizadores_scripts.Left := 577;
    div_totalizadores_scripts.Top := 51;
    div_totalizadores_scripts.Width := 347;
    div_totalizadores_scripts.Height := 141;
    div_totalizadores_scripts.ChildOrder := 3;
    div_totalizadores_scripts.Role := '';
    div_totalizadores_scripts.Visible := False;
    DIV_SCRIPTS.SetParentComponent(div_totalizadores_scripts);
    DIV_SCRIPTS.Name := 'DIV_SCRIPTS';
    DIV_SCRIPTS.Left := 8;
    DIV_SCRIPTS.Top := 4;
    DIV_SCRIPTS.Width := 106;
    DIV_SCRIPTS.Height := 62;
    DIV_SCRIPTS.Cursor := crHandPoint;
    DIV_SCRIPTS.ChildOrder := 5;
    DIV_SCRIPTS.Role := '';
    SetEvent(DIV_SCRIPTS, Self, 'OnClick', 'DIV_SCRIPTSClick');
    SCRIPTS.SetParentComponent(DIV_SCRIPTS);
    SCRIPTS.Name := 'SCRIPTS';
    SCRIPTS.Left := 3;
    SCRIPTS.Top := 21;
    SCRIPTS.Width := 96;
    SCRIPTS.Height := 13;
    SCRIPTS.Caption := 'Scripts Cadastrados';
    SCRIPTS.HeightPercent := 100.000000000000000000;
    SCRIPTS.WidthPercent := 100.000000000000000000;
    NUMERO_SCRIPTS.SetParentComponent(DIV_SCRIPTS);
    NUMERO_SCRIPTS.Name := 'NUMERO_SCRIPTS';
    NUMERO_SCRIPTS.Left := 32;
    NUMERO_SCRIPTS.Top := 43;
    NUMERO_SCRIPTS.Width := 3;
    NUMERO_SCRIPTS.Height := 13;
    NUMERO_SCRIPTS.HeightPercent := 100.000000000000000000;
    NUMERO_SCRIPTS.WidthPercent := 100.000000000000000000;
    DIV_SCRIPTS_ERRO.SetParentComponent(div_totalizadores_scripts);
    DIV_SCRIPTS_ERRO.Name := 'DIV_SCRIPTS_ERRO';
    DIV_SCRIPTS_ERRO.Left := 120;
    DIV_SCRIPTS_ERRO.Top := 70;
    DIV_SCRIPTS_ERRO.Width := 106;
    DIV_SCRIPTS_ERRO.Height := 62;
    DIV_SCRIPTS_ERRO.Cursor := crHandPoint;
    DIV_SCRIPTS_ERRO.ChildOrder := 5;
    DIV_SCRIPTS_ERRO.Role := '';
    SetEvent(DIV_SCRIPTS_ERRO, Self, 'OnClick', 'ChamarTelaScriptsAliados');
    SCRIPTS_ERRO.SetParentComponent(DIV_SCRIPTS_ERRO);
    SCRIPTS_ERRO.Name := 'SCRIPTS_ERRO';
    SCRIPTS_ERRO.Left := 11;
    SCRIPTS_ERRO.Top := 21;
    SCRIPTS_ERRO.Width := 92;
    SCRIPTS_ERRO.Height := 13;
    SCRIPTS_ERRO.Caption := 'Scripts Aliados Erro';
    SCRIPTS_ERRO.HeightPercent := 100.000000000000000000;
    SCRIPTS_ERRO.WidthPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_ERRO.SetParentComponent(DIV_SCRIPTS_ERRO);
    NUMERO_SCRIPTS_ERRO.Name := 'NUMERO_SCRIPTS_ERRO';
    NUMERO_SCRIPTS_ERRO.Left := 32;
    NUMERO_SCRIPTS_ERRO.Top := 43;
    NUMERO_SCRIPTS_ERRO.Width := 3;
    NUMERO_SCRIPTS_ERRO.Height := 13;
    NUMERO_SCRIPTS_ERRO.HeightPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_ERRO.WidthPercent := 100.000000000000000000;
    DIV_SCRIPTS_EXECUTADOS.SetParentComponent(div_totalizadores_scripts);
    DIV_SCRIPTS_EXECUTADOS.Name := 'DIV_SCRIPTS_EXECUTADOS';
    DIV_SCRIPTS_EXECUTADOS.Left := 8;
    DIV_SCRIPTS_EXECUTADOS.Top := 70;
    DIV_SCRIPTS_EXECUTADOS.Width := 106;
    DIV_SCRIPTS_EXECUTADOS.Height := 62;
    DIV_SCRIPTS_EXECUTADOS.Cursor := crHandPoint;
    DIV_SCRIPTS_EXECUTADOS.ChildOrder := 5;
    DIV_SCRIPTS_EXECUTADOS.Role := '';
    SetEvent(DIV_SCRIPTS_EXECUTADOS, Self, 'OnClick', 'ChamarTelaScriptsAliados');
    SCRIPTS_EXECUTADOS.SetParentComponent(DIV_SCRIPTS_EXECUTADOS);
    SCRIPTS_EXECUTADOS.Name := 'SCRIPTS_EXECUTADOS';
    SCRIPTS_EXECUTADOS.Left := 3;
    SCRIPTS_EXECUTADOS.Top := 21;
    SCRIPTS_EXECUTADOS.Width := 128;
    SCRIPTS_EXECUTADOS.Height := 13;
    SCRIPTS_EXECUTADOS.Caption := 'Scripts Aliados Executados';
    SCRIPTS_EXECUTADOS.HeightPercent := 100.000000000000000000;
    SCRIPTS_EXECUTADOS.WidthPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_EXECUTADOS.SetParentComponent(DIV_SCRIPTS_EXECUTADOS);
    NUMERO_SCRIPTS_EXECUTADOS.Name := 'NUMERO_SCRIPTS_EXECUTADOS';
    NUMERO_SCRIPTS_EXECUTADOS.Left := 32;
    NUMERO_SCRIPTS_EXECUTADOS.Top := 43;
    NUMERO_SCRIPTS_EXECUTADOS.Width := 3;
    NUMERO_SCRIPTS_EXECUTADOS.Height := 13;
    NUMERO_SCRIPTS_EXECUTADOS.HeightPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_EXECUTADOS.WidthPercent := 100.000000000000000000;
    DIV_SCRIPTS_EXECUTAR.SetParentComponent(div_totalizadores_scripts);
    DIV_SCRIPTS_EXECUTAR.Name := 'DIV_SCRIPTS_EXECUTAR';
    DIV_SCRIPTS_EXECUTAR.Left := 120;
    DIV_SCRIPTS_EXECUTAR.Top := 4;
    DIV_SCRIPTS_EXECUTAR.Width := 106;
    DIV_SCRIPTS_EXECUTAR.Height := 62;
    DIV_SCRIPTS_EXECUTAR.Cursor := crHandPoint;
    DIV_SCRIPTS_EXECUTAR.ChildOrder := 5;
    DIV_SCRIPTS_EXECUTAR.Role := '';
    SetEvent(DIV_SCRIPTS_EXECUTAR, Self, 'OnClick', 'ChamarTelaScriptsAliados');
    SCRIPTS_EXECUTAR.SetParentComponent(DIV_SCRIPTS_EXECUTAR);
    SCRIPTS_EXECUTAR.Name := 'SCRIPTS_EXECUTAR';
    SCRIPTS_EXECUTAR.Left := 3;
    SCRIPTS_EXECUTAR.Top := 21;
    SCRIPTS_EXECUTAR.Width := 124;
    SCRIPTS_EXECUTAR.Height := 13;
    SCRIPTS_EXECUTAR.Caption := 'Scripts Aliados a Executar';
    SCRIPTS_EXECUTAR.HeightPercent := 100.000000000000000000;
    SCRIPTS_EXECUTAR.WidthPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_EXECUTAR.SetParentComponent(DIV_SCRIPTS_EXECUTAR);
    NUMERO_SCRIPTS_EXECUTAR.Name := 'NUMERO_SCRIPTS_EXECUTAR';
    NUMERO_SCRIPTS_EXECUTAR.Left := 32;
    NUMERO_SCRIPTS_EXECUTAR.Top := 43;
    NUMERO_SCRIPTS_EXECUTAR.Width := 3;
    NUMERO_SCRIPTS_EXECUTAR.Height := 13;
    NUMERO_SCRIPTS_EXECUTAR.HeightPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_EXECUTAR.WidthPercent := 100.000000000000000000;
    DIV_TOTAL_SCRIPTS_ALIADOS.SetParentComponent(div_totalizadores_scripts);
    DIV_TOTAL_SCRIPTS_ALIADOS.Name := 'DIV_TOTAL_SCRIPTS_ALIADOS';
    DIV_TOTAL_SCRIPTS_ALIADOS.Left := 230;
    DIV_TOTAL_SCRIPTS_ALIADOS.Top := 4;
    DIV_TOTAL_SCRIPTS_ALIADOS.Width := 106;
    DIV_TOTAL_SCRIPTS_ALIADOS.Height := 62;
    DIV_TOTAL_SCRIPTS_ALIADOS.Cursor := crHandPoint;
    DIV_TOTAL_SCRIPTS_ALIADOS.ChildOrder := 5;
    DIV_TOTAL_SCRIPTS_ALIADOS.Role := '';
    SetEvent(DIV_TOTAL_SCRIPTS_ALIADOS, Self, 'OnClick', 'ChamarTelaScriptsAliados');
    TOTAL_SCRIPTS_ALIADOS.SetParentComponent(DIV_TOTAL_SCRIPTS_ALIADOS);
    TOTAL_SCRIPTS_ALIADOS.Name := 'TOTAL_SCRIPTS_ALIADOS';
    TOTAL_SCRIPTS_ALIADOS.Left := 3;
    TOTAL_SCRIPTS_ALIADOS.Top := 21;
    TOTAL_SCRIPTS_ALIADOS.Width := 96;
    TOTAL_SCRIPTS_ALIADOS.Height := 13;
    TOTAL_SCRIPTS_ALIADOS.Caption := 'Total Scripts Aliados';
    TOTAL_SCRIPTS_ALIADOS.HeightPercent := 100.000000000000000000;
    TOTAL_SCRIPTS_ALIADOS.WidthPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_ALIADOS.SetParentComponent(DIV_TOTAL_SCRIPTS_ALIADOS);
    NUMERO_SCRIPTS_ALIADOS.Name := 'NUMERO_SCRIPTS_ALIADOS';
    NUMERO_SCRIPTS_ALIADOS.Left := 32;
    NUMERO_SCRIPTS_ALIADOS.Top := 43;
    NUMERO_SCRIPTS_ALIADOS.Width := 3;
    NUMERO_SCRIPTS_ALIADOS.Height := 13;
    NUMERO_SCRIPTS_ALIADOS.HeightPercent := 100.000000000000000000;
    NUMERO_SCRIPTS_ALIADOS.WidthPercent := 100.000000000000000000;
    div_totalizadores_sinc_servidor.SetParentComponent(Self);
    div_totalizadores_sinc_servidor.Name := 'div_totalizadores_sinc_servidor';
    div_totalizadores_sinc_servidor.Left := 577;
    div_totalizadores_sinc_servidor.Top := 208;
    div_totalizadores_sinc_servidor.Width := 347;
    div_totalizadores_sinc_servidor.Height := 161;
    div_totalizadores_sinc_servidor.ChildOrder := 4;
    div_totalizadores_sinc_servidor.Role := '';
    div_totalizadores_sinc_servidor.Visible := False;
    DIV_ALIADOS_SINC_SERV_ATIVA.SetParentComponent(div_totalizadores_sinc_servidor);
    DIV_ALIADOS_SINC_SERV_ATIVA.Name := 'DIV_ALIADOS_SINC_SERV_ATIVA';
    DIV_ALIADOS_SINC_SERV_ATIVA.Left := 8;
    DIV_ALIADOS_SINC_SERV_ATIVA.Top := 3;
    DIV_ALIADOS_SINC_SERV_ATIVA.Width := 113;
    DIV_ALIADOS_SINC_SERV_ATIVA.Height := 62;
    DIV_ALIADOS_SINC_SERV_ATIVA.Cursor := crHandPoint;
    DIV_ALIADOS_SINC_SERV_ATIVA.ChildOrder := 5;
    DIV_ALIADOS_SINC_SERV_ATIVA.Role := '';
    SetEvent(DIV_ALIADOS_SINC_SERV_ATIVA, Self, 'OnClick', 'ChamarTelaAliado');
    SINC_SERV_ALIADOS_ATIVOS.SetParentComponent(DIV_ALIADOS_SINC_SERV_ATIVA);
    SINC_SERV_ALIADOS_ATIVOS.Name := 'SINC_SERV_ALIADOS_ATIVOS';
    SINC_SERV_ALIADOS_ATIVOS.Left := 5;
    SINC_SERV_ALIADOS_ATIVOS.Top := 17;
    SINC_SERV_ALIADOS_ATIVOS.Width := 105;
    SINC_SERV_ALIADOS_ATIVOS.Height := 13;
    SINC_SERV_ALIADOS_ATIVOS.Caption := 'Sincroniza'#231#227'o Iniciada';
    SINC_SERV_ALIADOS_ATIVOS.HeightPercent := 100.000000000000000000;
    SINC_SERV_ALIADOS_ATIVOS.WidthPercent := 100.000000000000000000;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.SetParentComponent(DIV_ALIADOS_SINC_SERV_ATIVA);
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.Name := 'NUMERO_SINC_SERV_ALIADOS_ATIVOS';
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.Left := 32;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.Top := 43;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.Width := 3;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.Height := 13;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.HeightPercent := 100.000000000000000000;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SINC_SERV_ERRO.SetParentComponent(div_totalizadores_sinc_servidor);
    DIV_ALIADOS_SINC_SERV_ERRO.Name := 'DIV_ALIADOS_SINC_SERV_ERRO';
    DIV_ALIADOS_SINC_SERV_ERRO.Left := 124;
    DIV_ALIADOS_SINC_SERV_ERRO.Top := 3;
    DIV_ALIADOS_SINC_SERV_ERRO.Width := 106;
    DIV_ALIADOS_SINC_SERV_ERRO.Height := 62;
    DIV_ALIADOS_SINC_SERV_ERRO.Cursor := crHandPoint;
    DIV_ALIADOS_SINC_SERV_ERRO.ChildOrder := 5;
    DIV_ALIADOS_SINC_SERV_ERRO.Role := '';
    SetEvent(DIV_ALIADOS_SINC_SERV_ERRO, Self, 'OnClick', 'ChamarTelaAliado');
    SINC_SERV_ALIADOS_ERRO.SetParentComponent(DIV_ALIADOS_SINC_SERV_ERRO);
    SINC_SERV_ALIADOS_ERRO.Name := 'SINC_SERV_ALIADOS_ERRO';
    SINC_SERV_ALIADOS_ERRO.Left := 13;
    SINC_SERV_ALIADOS_ERRO.Top := 17;
    SINC_SERV_ALIADOS_ERRO.Width := 88;
    SINC_SERV_ALIADOS_ERRO.Height := 13;
    SINC_SERV_ALIADOS_ERRO.Caption := 'Erro Sincroniza'#231#227'o';
    SINC_SERV_ALIADOS_ERRO.HeightPercent := 100.000000000000000000;
    SINC_SERV_ALIADOS_ERRO.WidthPercent := 100.000000000000000000;
    NUMERO_SINC_SERV_ALIADOS_ERRO.SetParentComponent(DIV_ALIADOS_SINC_SERV_ERRO);
    NUMERO_SINC_SERV_ALIADOS_ERRO.Name := 'NUMERO_SINC_SERV_ALIADOS_ERRO';
    NUMERO_SINC_SERV_ALIADOS_ERRO.Left := 32;
    NUMERO_SINC_SERV_ALIADOS_ERRO.Top := 43;
    NUMERO_SINC_SERV_ALIADOS_ERRO.Width := 3;
    NUMERO_SINC_SERV_ALIADOS_ERRO.Height := 13;
    NUMERO_SINC_SERV_ALIADOS_ERRO.HeightPercent := 100.000000000000000000;
    NUMERO_SINC_SERV_ALIADOS_ERRO.WidthPercent := 100.000000000000000000;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.SetParentComponent(div_totalizadores_sinc_servidor);
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Name := 'DIV_ALIADOS_SINC_SERV_NAO_INICIADA';
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Left := 234;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Top := 3;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Width := 110;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Height := 62;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Cursor := crHandPoint;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.ChildOrder := 5;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.Role := '';
    SetEvent(DIV_ALIADOS_SINC_SERV_NAO_INICIADA, Self, 'OnClick', 'ChamarTelaAliado');
    ALIADOS_SINC_SERV_NAO_INICIADA.SetParentComponent(DIV_ALIADOS_SINC_SERV_NAO_INICIADA);
    ALIADOS_SINC_SERV_NAO_INICIADA.Name := 'ALIADOS_SINC_SERV_NAO_INICIADA';
    ALIADOS_SINC_SERV_NAO_INICIADA.Left := 3;
    ALIADOS_SINC_SERV_NAO_INICIADA.Top := 17;
    ALIADOS_SINC_SERV_NAO_INICIADA.Width := 127;
    ALIADOS_SINC_SERV_NAO_INICIADA.Height := 13;
    ALIADOS_SINC_SERV_NAO_INICIADA.Caption := 'Sincroniza'#231#227'o N'#227'o Iniciada';
    ALIADOS_SINC_SERV_NAO_INICIADA.HeightPercent := 100.000000000000000000;
    ALIADOS_SINC_SERV_NAO_INICIADA.WidthPercent := 100.000000000000000000;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.SetParentComponent(DIV_ALIADOS_SINC_SERV_NAO_INICIADA);
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.Name := 'NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA';
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.Left := 32;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.Top := 43;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.Width := 3;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.Height := 13;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.HeightPercent := 100.000000000000000000;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.WidthPercent := 100.000000000000000000;
    DIV_ATUALIZAR_DADOS_REDIS.SetParentComponent(div_totalizadores_sinc_servidor);
    DIV_ATUALIZAR_DADOS_REDIS.Name := 'DIV_ATUALIZAR_DADOS_REDIS';
    DIV_ATUALIZAR_DADOS_REDIS.Left := 16;
    DIV_ATUALIZAR_DADOS_REDIS.Top := 83;
    DIV_ATUALIZAR_DADOS_REDIS.Width := 113;
    DIV_ATUALIZAR_DADOS_REDIS.Height := 62;
    DIV_ATUALIZAR_DADOS_REDIS.Cursor := crHandPoint;
    DIV_ATUALIZAR_DADOS_REDIS.ChildOrder := 5;
    DIV_ATUALIZAR_DADOS_REDIS.Role := '';
    SetEvent(DIV_ATUALIZAR_DADOS_REDIS, Self, 'OnClick', 'DIV_ATUALIZAR_DADOS_REDISClick');
    ATUALIZAR_DADOS_REDIS.SetParentComponent(DIV_ATUALIZAR_DADOS_REDIS);
    ATUALIZAR_DADOS_REDIS.Name := 'ATUALIZAR_DADOS_REDIS';
    ATUALIZAR_DADOS_REDIS.Left := 5;
    ATUALIZAR_DADOS_REDIS.Top := 17;
    ATUALIZAR_DADOS_REDIS.Width := 104;
    ATUALIZAR_DADOS_REDIS.Height := 13;
    ATUALIZAR_DADOS_REDIS.Caption := 'Atualizar Dados Redis';
    ATUALIZAR_DADOS_REDIS.HeightPercent := 100.000000000000000000;
    ATUALIZAR_DADOS_REDIS.WidthPercent := 100.000000000000000000;
    XDataClient.SetParentComponent(Self);
    XDataClient.Name := 'XDataClient';
    XDataClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClient, Self, 'OnLoad', 'XDataClientLoad');
    XDataClient.Left := 600;
    XDataClientAtualizarRTRedis.SetParentComponent(Self);
    XDataClientAtualizarRTRedis.Name := 'XDataClientAtualizarRTRedis';
    XDataClientAtualizarRTRedis.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAtualizarRTRedis, Self, 'OnLoad', 'XDataClientAtualizarRTRedisLoad');
    SetEvent(XDataClientAtualizarRTRedis, Self, 'OnError', 'XDataClientAtualizarRTRedisError');
    XDataClientAtualizarRTRedis.Left := 688;
    XDataClientAtualizarRTRedis.Top := 8;
  finally
    WebLabel1.AfterLoadDFMValues;
    div_totalizadores_aliados.AfterLoadDFMValues;
    DIV_CLIENTES.AfterLoadDFMValues;
    CLIENTES.AfterLoadDFMValues;
    NUMERO_CLIENTES.AfterLoadDFMValues;
    DIV_PRODUTOS.AfterLoadDFMValues;
    PRODUTOS.AfterLoadDFMValues;
    NUMERO_PRODUTOS.AfterLoadDFMValues;
    DIV_FUNCIONARIOS.AfterLoadDFMValues;
    FUNCIONARIOS.AfterLoadDFMValues;
    NUMERO_FUNCIONARIOS.AfterLoadDFMValues;
    DIV_COMPRAS.AfterLoadDFMValues;
    COMPRAS.AfterLoadDFMValues;
    NUMERO_COMPRAS.AfterLoadDFMValues;
    DIV_CONTADORES.AfterLoadDFMValues;
    CONTADORES.AfterLoadDFMValues;
    NUMERO_CONTADORES.AfterLoadDFMValues;
    DIV_FORNECEDORES.AfterLoadDFMValues;
    FORNECEDORES.AfterLoadDFMValues;
    NUMERO_FORNECEDORES.AfterLoadDFMValues;
    DIV_CUPONS.AfterLoadDFMValues;
    CUPONS.AfterLoadDFMValues;
    NUMERO_CUPONS.AfterLoadDFMValues;
    DIV_VENDAS.AfterLoadDFMValues;
    VENDAS.AfterLoadDFMValues;
    NUMERO_VENDAS.AfterLoadDFMValues;
    div_totalizadores_facil.AfterLoadDFMValues;
    DIV_ALIADOS_ATIVOS.AfterLoadDFMValues;
    ALIADOS_ATIVOS.AfterLoadDFMValues;
    NUMERO_ALIADOS_ATIVOS.AfterLoadDFMValues;
    DIV_ALIADOS_SUSPENSOS.AfterLoadDFMValues;
    ALIADOS_SUSPENSOS.AfterLoadDFMValues;
    NUMERO_ALIADOS_SUSPENSOS.AfterLoadDFMValues;
    DIV_ALIADOS_SINCRONIZACAO_ATIVA.AfterLoadDFMValues;
    ALIADOS_SINCRONIZACAO_ATIVA.AfterLoadDFMValues;
    NUMERO_ALIADOS_SINCRONIZACAO_ATIVA.AfterLoadDFMValues;
    DIV_ALIADOS_SEM_PARCEIRO.AfterLoadDFMValues;
    ALIADOS_SEM_PARCEIRO.AfterLoadDFMValues;
    NUMERO_ALIADOS_SEM_PARCEIRO.AfterLoadDFMValues;
    DIV_ALIADOS_SEM_SEGMENTO.AfterLoadDFMValues;
    ALIADOS_SEM_SEGMENTO.AfterLoadDFMValues;
    NUMERO_ALIADOS_SEM_SEGMENTO.AfterLoadDFMValues;
    DIV_ALIADOS_ERRO_SINCRONIZACAO.AfterLoadDFMValues;
    ALIADOS_ERRO_SINCRONIZACAO.AfterLoadDFMValues;
    NUMERO_ALIADOS_ERRO_SINCRONIZACAO.AfterLoadDFMValues;
    DIV_ALIADOS_SINCRONIZACAO_NAO_INICIADA.AfterLoadDFMValues;
    ALIADOS_SINCRONIZACAO_NAO_INICIADA.AfterLoadDFMValues;
    NUMERO_ALIADOS_SINCRONIZACAO_NAO_INICIADA.AfterLoadDFMValues;
    DIV_ALIADOS_SINCRONIZACAO_ATRASADA.AfterLoadDFMValues;
    ALIADOS_SINCRONIZACAO_ATRASADA.AfterLoadDFMValues;
    NUMERO_ALIADOS_SINCRONIZACAO_ATRASADA.AfterLoadDFMValues;
    DIV_ALIADOS_UTILITARIOS_DESATUALIZADO.AfterLoadDFMValues;
    ALIADOS_UTILITARIOS_DESATUALIZADO.AfterLoadDFMValues;
    NUMERO_ALIADOS_UTILITARIOS_DESATUALIZADO.AfterLoadDFMValues;
    DIV_TOKENS_DUPLICADOS.AfterLoadDFMValues;
    TOKENS_DUPLICADOS.AfterLoadDFMValues;
    NUMERO_TOKENS_DUPLICADOS.AfterLoadDFMValues;
    DIV_PRODUTOS_APROVACAO_PENDENTE.AfterLoadDFMValues;
    PRODUTOS_APROVACAO_PENDENTE.AfterLoadDFMValues;
    NUMERO_PRODUTOS_APROVACAO_PENDENTE.AfterLoadDFMValues;
    div_totalizadores_scripts.AfterLoadDFMValues;
    DIV_SCRIPTS.AfterLoadDFMValues;
    SCRIPTS.AfterLoadDFMValues;
    NUMERO_SCRIPTS.AfterLoadDFMValues;
    DIV_SCRIPTS_ERRO.AfterLoadDFMValues;
    SCRIPTS_ERRO.AfterLoadDFMValues;
    NUMERO_SCRIPTS_ERRO.AfterLoadDFMValues;
    DIV_SCRIPTS_EXECUTADOS.AfterLoadDFMValues;
    SCRIPTS_EXECUTADOS.AfterLoadDFMValues;
    NUMERO_SCRIPTS_EXECUTADOS.AfterLoadDFMValues;
    DIV_SCRIPTS_EXECUTAR.AfterLoadDFMValues;
    SCRIPTS_EXECUTAR.AfterLoadDFMValues;
    NUMERO_SCRIPTS_EXECUTAR.AfterLoadDFMValues;
    DIV_TOTAL_SCRIPTS_ALIADOS.AfterLoadDFMValues;
    TOTAL_SCRIPTS_ALIADOS.AfterLoadDFMValues;
    NUMERO_SCRIPTS_ALIADOS.AfterLoadDFMValues;
    div_totalizadores_sinc_servidor.AfterLoadDFMValues;
    DIV_ALIADOS_SINC_SERV_ATIVA.AfterLoadDFMValues;
    SINC_SERV_ALIADOS_ATIVOS.AfterLoadDFMValues;
    NUMERO_SINC_SERV_ALIADOS_ATIVOS.AfterLoadDFMValues;
    DIV_ALIADOS_SINC_SERV_ERRO.AfterLoadDFMValues;
    SINC_SERV_ALIADOS_ERRO.AfterLoadDFMValues;
    NUMERO_SINC_SERV_ALIADOS_ERRO.AfterLoadDFMValues;
    DIV_ALIADOS_SINC_SERV_NAO_INICIADA.AfterLoadDFMValues;
    ALIADOS_SINC_SERV_NAO_INICIADA.AfterLoadDFMValues;
    NUMERO_SINC_SERV_ALIADOS_NAO_INICIADA.AfterLoadDFMValues;
    DIV_ATUALIZAR_DADOS_REDIS.AfterLoadDFMValues;
    ATUALIZAR_DADOS_REDIS.AfterLoadDFMValues;
    XDataClient.AfterLoadDFMValues;
    XDataClientAtualizarRTRedis.AfterLoadDFMValues;
  end;
end;

end.
